// src/data/quizData.js
export const quizData = [
  {
    id: 1,
    question: '我對科技、知識、心靈成長方面的新發展、新發現很感興趣，也會不斷地充實自己這方面的知識。',
  },
  {
    id: 2,
    question: '在我做任何決定前，即使是生活中的小事，總是喜歡徵求朋友或家人的建議和看法。',
  },
  {
    id: 3,
    question: '我是個有條理的人，喜歡把該做的事逐項地規劃出來，可是有時列出來的專案，多到不知該如何著手。',
  },
  {
    id: 4,
    question: '我對暴力、武器和功夫相當癡迷，喜歡那些充滿暴力和打鬥的電影、影集或是遊戲。',
  },
  {
    id: 5,
    question: '我有很豐富的想像力，當別人描述一個物品或事件時，我可以在腦海中清楚地描繪出該項物品或事件的影像。',
  },
  {
    id: 6,
    question: '當我做決定時，必須要考慮周詳，且分析它的來龍去脈後，才能做下明確的抉擇，因此有人認為我優柔寡斷。',
  },
  {
    id: 7,
    question: '我很瞭解自己的能力、天賦、想從事的工作，以及什麼對我而言，才是人生最重要的。',
  },
  {
    id: 8,
    question: '我時常嫉妒別人的好運或財富，處在際遇比我好的人群中，讓我有低人一等的不自在。',
  },
  {
    id: 9,
    question: '在社交場合中，因為我怕會有不得體的言語或行為出現，所以盡可能有所保留。',
  },
  {
    id: 10,
    question: '我通常必須確定對方是真正喜歡我後，才會與他做更深一層的交往。',
  },
  {
    id: 11,
    question: '在社交場合中，我是個非常有自信的人，能夠輕鬆自然、反應得體的與人交談，不會讓人有矯揉造作、不安的感覺。',
  },
  {
    id: 12,
    question: '我喜歡獨自爬山、逛街、看電影等，並不需要任何人，甚至是家人的陪伴。我喜愛個人自由、清靜的空間。',
  },
  {
    id: 13,
    question: '我偶爾會捏造一個故事或是歪曲事實，然後看別人的反應。但這樣做只是想開別人玩笑罷了，一點惡意也沒有。',
  },
  {
    id: 14,
    question: '仔細想想，我覺得自己在生活中真正喜歡，或能安心享樂的事，實在不多。',
  },
  {
    id: 15,
    question: '我不是個一板一眼的人，我喜歡做些緊張、刺激的事，如：飆車、酒後開車等，但我很明白自己的所作所為。',
  },
  {
    id: 16,
    question: '我喜歡精打細算，雖然有人認為我吝嗇，但我相信每個人應該都有儲蓄的好習慣，以備不時之需。',
  },
  {
    id: 17,
    question: '我周遭親近的人，常說我老是看到事情不好的一面，他們說我的心態太消極悲觀了。',
  },
  {
    id: 18,
    question: '當我情緒不好時，我會有相當誇大的表達方式，例如，大哭一場，摔破物品以洩憤，或是有自我傷害的行為出現。',
  },
  {
    id: 19,
    question: '我的親友說，我小時候是個專門惹是生非的小搗蛋。我曾翹課、打架、說謊等，都是些令人頭痛的事情。',
  },
  {
    id: 20,
    question: '我從小到現在，一直是大家心目中的乖寶寶，從不做一些違反規定、父母師長不允許的事情。',
  },
  {
    id: 21,
    question: '我對靈異的事情很感興趣，有敏銳的「第六感」，常常在事情還未發生前，就能感受到有某件事情將要發生。',
  },
  {
    id: 22,
    question: '在社交場合或是平日的活動中，我總喜歡成為眾人注目的焦點，不太安於配角或跑龍套的這種角色。',
  },
  {
    id: 23,
    question: '我崇尚浪漫、狂野的愛情，常常瘋狂的投入一段戀情中。但有時會因為對方的一些小缺點，而無法克制厭惡及憤怒的情緒。',
  },
  {
    id: 24,
    question: '有人說我沒有什麼情緒變化，表情冷漠，甚至有人說我是「撲克臉孔」。',
  },
  {
    id: 25,
    question: '我凡事不喜歡被束縛、被限制，做事一向隨興而為。擬定生涯規劃、依循行事規章等，對我而言太難了。',
  },
  {
    id: 26,
    question: '我擅長人際社交，處在人群中，往往是被眾星拱月、目光焦聚的那個人。',
  },
  {
    id: 27,
    question: '雖然大家都說「內在美」比「外在美」重要，可是我覺得一個人的外貌是不可忽略。因此每天會花費時間來裝扮自己，確定自己看起來美麗動人或是英俊瀟灑。',
  },
  {
    id: 28,
    question: '當與他人相處時，我發現有時候自己無法完全放鬆，享受歡樂的時光。除非，確定其他人的需求都已經被滿足了。',
  },
  {
    id: 29,
    question: '我通常讓我的家人或伴侶，來幫我做重要的決定。',
  },
  {
    id: 30,
    question: '當有人真正關心我，給予我許多的關懷和溫馨時，我通常會覺得很不自在，且難以接受；但我喜愛為他人解決困難。',
  },
  {
    id: 31,
    question: '我是完美主義者，對自我往往要求嚴苛，所以我比一般人花更多時間在份內的工作上。',
  },
  {
    id: 32,
    question: '或許我有點自我膨脹，可是我自認自己是個蠻特殊的人物。',
  },
  {
    id: 33,
    question: '有人覺得我會與他人保持某些距離，而且在生活和衣著上，有自己特殊的風格，所以有些人認為我是個「奇怪的人」。',
  },
  {
    id: 34,
    question: '當事情不如我意時，我會忍不住暴跳如雷，不分場合、對象、後果，大發脾氣，有時會將場面搞得很僵。',
  },
  {
    id: 35,
    question: '我不喜歡人聲鼎沸、摩肩接踵的廟會、狂歡晚會、社交場合、人與人間的頻繁相處，讓我身心疲憊。',
  },
  {
    id: 36,
    question: '我的同事和上司，並不能真正瞭解、激賞和重用我的才華。',
  },
  {
    id: 37,
    question: '除了我親近的家人外，我只有二、三知己。',
  },
  {
    id: 38,
    question: '在陌生人群中，我常常會不知所措，感到害羞或焦慮。',
  },
  {
    id: 39,
    question: '做事時，我常常會覺得後繼無力，有時會半途而廢，要不然就是用拖拖拉拉，差不多的辦法來草草了事，敷衍交差。',
  },
  {
    id: 40,
    question: '我是個非常注重隱私的人，我不輕易跟人分享我個人的資料。因為你永遠不知道別人會如何利用這些資料，來做為謀取利益或算計你的工具。',
  },
  {
    id: 41,
    question: '我喜歡在群眾間放送魅力，並且希望別人覺得我很性感、很有吸引力。',
  },
  {
    id: 42,
    question: '當一段親密的友誼或愛情結束時，我會覺得孤單無依、彷徨無助，常不自覺地急著尋求新的親密關係。',
  },
  {
    id: 43,
    question: '我認為嚴格的管理非常重要，我深信員工需要有嚴謹訓練，必需確切遵循公司規範。',
  },
  {
    id: 44,
    question: '當別人批評我或是稱讚我時，我通常都不會有明顯或強烈的情緒反應。',
  },
  {
    id: 45,
    question: '我的情緒常因外在的環境起伏變化很大，可是我無力也無法控管。',
  },
  {
    id: 46,
    question: '我喜歡呼朋引伴、聚餐、唱卡拉OK，我就是受不了獨處，尤其熱愛與一群同伴狂歡作樂，參加派對，享受刺激。',
  },
  {
    id: 47,
    question: '如果我有選擇餘地的話，我寧願獨自處理事情或獨來獨往。',
  },
  {
    id: 48,
    question: '我喜歡用一種生動、活潑、戲劇性的方式來表達我的感覺，或描述事件。',
  },
  {
    id: 49,
    question: '有人告訴我：我是一個很有個性的人。不管是誰把我惹毛，我都會禁不住想與對方理論或是爭出輸贏。',
  },
  {
    id: 50,
    question: '我對別人心中的企圖有種特殊敏銳的覺察力，即使這個企圖只在醞釀的初期階段，我都能感受到。',
  },
  {
    id: 51,
    question: '當我處在很大壓力下，可能變得有點偏執。有時會胡思亂想、疑神疑鬼，或以置之不理的方式來做逃避。',
  },
  {
    id: 52,
    question: '我崇尚可遊走在法令邊緣，但不會被懲罰的生活。',
  },
  {
    id: 53,
    question: '我的情緒平和，很少有大吼大叫，失去控制的狀況發生。',
  },
  {
    id: 54,
    question: '我很依賴我生命中親密的夥伴，常擔心如果有一天失去他的話，可能沒能力照顧自己。',
  },
  {
    id: 55,
    question: '我喜歡付出、滿足別人的需求，有時覺得自己為他人付出太多了。',
  },
  {
    id: 56,
    question: '我是個成功，有聲名、地位，或是有才幹的人。所以，在某些場合，應該得到某方面特殊的禮遇。',
  },
  {
    id: 57,
    question: '有人說我有「收集癖」。對那些老舊、無用，沒有任何實際價值或抽象意義的物品，總捨不得丟棄。',
  },
  {
    id: 58,
    question: '我不喜歡一成不變的工作，往往為了要從事自己喜歡的事，而無法將份內工作，做得很完善。有時會使出「拖」手段，或是把該做的事，暫時擱一邊。',
  },
  {
    id: 59,
    question: '朋友常說我猶如古代的俠客，喜歡「路見不平，拔刀相助」，是現代的「正義之聲」。',
  },
  {
    id: 60,
    question: '有人說我驕傲自大，可是我完全不在乎他人評論。',
  },
  {
    id: 61,
    question: '在大型的社交場合中，常令我感到焦慮不安，即使與熟識的人在一起，還是會覺得別人用評估的眼光打量著我。',
  },
  {
    id: 62,
    question: '我是個有名的膽小鬼，幾乎什麼新奇的玩意兒都不肯輕易嘗試，我喜歡生活在熟悉的生活空間裡。',
  },
  {
    id: 63,
    question: '朋友常說我是個理智型的人，每件事都會再三思考及分析後，才會去實行。有時甚至會有過度煩憂的傾向。',
  },
  {
    id: 64,
    question: '我不太在乎別人的看法，我的情緒表達隨著當時內在的感觸而定，所以有時會有不合時宜的事件發生。',
  },
  {
    id: 65,
    question: '我沒有耐性長期從事一成不變的工作。對於生活必需的雜事，我並不在行。所以有些人認為我不負責任。',
  },
  {
    id: 66,
    question: '有人曾告訴過我，我情緒表達的方式十分誇張，令他們搞不清楚事情的真實性到底有多少。',
  },
  {
    id: 67,
    question: '我家中成員，或公司部屬，抱怨我制定的規則過多，且太過嚴苛，沒有給予他們足夠獨立自主的空間。',
  },
  {
    id: 68,
    question: '若有對我不忠誠、不尊重，或是有不公平的待遇，我可能懷恨在心，久久無法釋懷。',
  },
  {
    id: 69,
    question: '在幫助別人、為別人付出的過程中，我找到了人生的意義和最大的快樂。',
  },
  {
    id: 70,
    question: '如果當我「該」做的事和我「想」做的事，發生衝突時，我會矛盾、掙扎，雖然免不了有愧疚之心，但十之八九會選擇我「想」做的事。',
  },
  {
    id: 71,
    question: '我可能是個深具威嚴的人，因為有人曾告訴我，他們遵循我的指令，是因為他們怕我。',
  },
  {
    id: 72,
    question: '我非常地情緒化，一點小事就足以使我大發雷霆，且在短短的幾個小時中，從快樂到憂傷，從焦慮到生氣。可是往往負面情緒，都不會持續太久。',
  },
  {
    id: 73,
    question: '我不喜歡嘗試冒險或新奇的事物，一則我怕面對不可知，再則我怕會丟人現眼。',
  },
  {
    id: 74,
    question: '我喜歡放縱自己，一切跟著感覺走，如果感覺對時，可能會買醉狂歡，也可能會飆車或是「大買特買」。',
  },
  {
    id: 75,
    question: '我不喜歡人與人之間勾心鬥角、交際應酬等，這些錯綜複雜的人際關係。我最大的心願就是能放下世俗的一切，隱居山林。',
  },
  {
    id: 76,
    question: '常有人說：我是個「工作狂」。即使目前已有足夠家產，我仍然會認真工作。',
  },
  {
    id: 77,
    question: '我喜歡想像自己擁有財富、權勢或名氣，而備受讚賞，或是由於自己的才能或美貌受到大眾的喜好及崇拜。',
  },
  {
    id: 78,
    question: '我會盡所能的為他人服務，有時免不了造成本身的一些不便，但還是會想盡辦法讓別人喜歡我。',
  },
  {
    id: 79,
    question: '我常常會誤認別人有意要追求我，或是對我有好感，這種揣測，有時不免對我造成困擾或不可避免的尷尬場面。',
  },
  {
    id: 80,
    question: '面對愛情，我沒有強烈的憧憬和欲望。',
  },
  {
    id: 81,
    question: '在生活中，我不會因為某方面的成功而欣喜異常，總會意識到在人生的某一方面，有困難發生。',
  },
  {
    id: 82,
    question: '在與人相處時，我喜歡表現出附和對方的態度，當不同意某個人的看法，只會把不滿的情緒放在心裡。',
  },
  {
    id: 83,
    question: '從小到現在，常有師長、長輩告訴我，如果我凡事多努力些，一定會有比現在更好的成就。',
  },
  {
    id: 84,
    question: '有時候我覺得周遭的人，包括：家人、朋友、同事，對我並不如期待中那麼的忠誠。',
  },
  {
    id: 85,
    question: '我相信在某些狀況下，必須犧牲他人利益，以達成自我目標。',
  },
  {
    id: 86,
    question: '我對上位者或是上司，常帶著批判的態度，或許我並沒有真正瞭解到他們立場，但我相信我能把事情處理得比他們好。',
  },
  {
    id: 87,
    question: '別人覺得我是一個非常幽默風趣的人，可以把日常平凡無奇的事，描述得生動有趣、引人入勝。',
  },
  {
    id: 88,
    question: '我發現自己會嘲諷別人的不幸，雖然我不以這種行徑為榮，但只想表達這是個「弱肉強食」的社會狀態罷了！',
  },
  {
    id: 89,
    question: '我對自己沒有強烈的自信心，常對自我的能力感到懷疑，有時候甚至覺得自己一無是處。',
  },
  {
    id: 90,
    question: '我腦袋裡，常充滿紛紛擾擾的思緒，我喜歡花費大把時間、精力，去捕捉腦內思緒，努力探索解答。因此，常疏忽現實生活的柴米油鹽。',
  },
  {
    id: 91,
    question: '我不是個積極主動的人，在團體中，寧願做個追隨者，成為一個安分守己且十分忠誠的成員。',
  },
  {
    id: 92,
    question: '我會毫不猶豫向人傾訴我的困擾，但當別人想給予我資助及關懷時，卻往往無法坦然接受。',
  },
  {
    id: 93,
    question: '有人說我說話有時太過尖酸刻薄、不留情面，但如果他們認為我太過吹毛求疵的話，就應該勇敢為自己辯護。',
  },
  {
    id: 94,
    question: '我想我的接收力與大多數的人不同，有時可以感受到一些奇怪的事，雖然無法證實或解說這些現象，但對我而言，它們是那麼的真確，例如：看到死去的親人或感受到特殊的能量等等。',
  },
  {
    id: 95,
    question: '我希望自己不那麼擔憂，別人對我在社交場合的看法。',
  },
  {
    id: 96,
    question: '當別人要求我去做一件我不想做的事，我會以爭辯、生氣或是鬧彆扭的方式來做抗爭，讓他們不能「輕易得逞」。',
  },
  {
    id: 97,
    question: '在思想上，我是個自由激進的人，會向傳統思維挑戰，也不在乎別人對我有何看法。',
  },
  {
    id: 98,
    question: '有人說我太過固執己見，凡事都要依照自己特有的行事方法去做，且親自監督。我寧願別人罵我頑固，也不要他們亂搞一通或是半途而廢。',
  },
  {
    id: 99,
    question: '我有時會為了捉弄他人、逃避責任，或是為自己牟利而不告訴別人事實的真相。',
  },
  {
    id: 100,
    question: '我是個缺乏安全感的人，在我的親密關係中，我經常擔心伴侶對我是否忠誠。',
  },
  {
    id: 101,
    question: '我喜歡保有個人隱私，因此對個人情感、嗜好、事件都多所保留，因此有人說我是個世故圓滑的人，常常猜不到我葫蘆裡賣的是什麼藥。',
  },
  {
    id: 102,
    question: '我對人心懷戒心，不輕易信賴他人，有時會試著去相信別人，但常不自禁地擔心他人會占我便宜。',
  },
  {
    id: 103,
    question: '有人會認為我常無病呻吟，但他們不瞭解這些不幸的事情，確實發生在我身上。',
  },
  {
    id: 104,
    question: '有人說我自找苦吃，不斷與一些令自己失望的人交往，讓自己傷心痛苦。我實在無法理解為什麼自己這麼缺乏判斷力。',
  },
  {
    id: 105,
    question: '我位居上流階層，和我交往的人，或是我所加入的組織、俱樂部等，都具有相當的影響力和重要性。',
  },
  {
    id: 106,
    question: '我覺得我的內在世界空洞，不知自己的定位在哪裡？也無法尋找到我人生的目標和意義。',
  },
  {
    id: 107,
    question: '我喜歡自己平常做事的方法，如果別人試著想改變我這些行事原則的話，我會擇善固執，對別人的意見不加以理睬。',
  },
  {
    id: 108,
    question: '有人說，我是個拖拖拉拉或差不多先生(差不多小姐)。我的人生觀是：人生苦短，要及時行樂，凡事做得過得去就可以，不需要事事追求完美。',
  },
  {
    id: 109,
    question: '有人說，我表達的方式很獨特，他們認為我所說的事，對他們而言太過深奧，或者甚至不瞭解我談話的內容。',
  },
  {
    id: 110,
    question: '我認為，我不需要對自己過去不良的行為感到內疚，或是有任何的罪惡感。',
  },
  {
    id: 111,
    question: '別人對我說，我對自我的要求太過嚴苛，常為一些小事自責過深。',
  },
  {
    id: 112,
    question: '有人說我很自我中心，雖然我自認瞭解別人的心情，但他們老是告訴我，我無法體會他們的感受。',
  },
  {
    id: 113,
    question: '對我而言，嫉妒是人生的一部分，不是我嫉妒著別人的財富、成就，就是有人可能嫉妒著我所擁有的一切。',
  },
  {
    id: 114,
    question: '我無法忍受嚴苛的社會現實面，因此我休閒時喜歡沉溺於追星、偶像劇、時尚等，浪漫氛圍裡。',
  },
  {
    id: 115,
    question: '我不是個非常主觀的人，因此容易受他人影響，我必須時時提醒自己這一點，要不然常常會被他人的意見所左右。',
  },
  {
    id: 116,
    question: '在人群中，我覺得安全無憂。若要孤獨地去面對人生，我會彷徨失措，完全不知該如何來照顧自己。',
  },
  {
    id: 117,
    question: '有人認為我太過保守和嚴苛，可是我深信沒有任何理由和藉口，可以原諒那些違反道德規範的行為。',
  },
  {
    id: 118,
    question: '我不是快樂無憂的人，有很多煩憂壓在我心上，並且有比較嚴謹保守的傾向。',
  },
  {
    id: 119,
    question: '我有天馬行空的想像力，在朋友圈中，我以點子多出名，有人說我是個「點子王」。',
  },
  {
    id: 120,
    question: '我喜歡接受讚美，當才華被肯定時，是我最高興的一件事，一旦覺得自己被忽視時，我會想辦法博取他人對我的讚賞。',
  },
  {
    id: 121,
    question: '我有時候擔心自己關心的人，或是親近朋友不喜歡我，會去試探，並要他們再三保證對我的忠誠和愛戀。我想這對他們而言，可能會造成某種程度的困擾。',
  },
  {
    id: 122,
    question: '在人數不多的工作場合，我覺得比較自在，因為受不了我的工作能力被其他同事質疑、批評。',
  },
  {
    id: 123,
    question: '朋友說，我是個善變的動物，他們形容我的情緒像不斷翻頁的書，喜怒無常，不是個容易相處的人。',
  },
  {
    id: 124,
    question: '在人際關係中，不管在公司或在家裡，我總喜歡居於主控的地位，有時讓他人覺得很粗魯或是嚴苛，而不自覺。',
  },
  {
    id: 125,
    question: '朋友說，我是個有才幹的人，會利用這些才能來幫助別人。但似乎沒有利用到這些天賦，來使自己在事業上或是家庭中得到利益。',
  },
  {
    id: 126,
    question: '面對挑戰，我會謹慎評估可能的風險、勝算，必須有十拿九穩的把握，才會放手去做。',
  },
  {
    id: 127,
    question: '我發現有一些人故意做一些煩擾、侮辱我的事，他們的目的只是想挑釁我。',
  },
  {
    id: 128,
    question: '有人說我天真無知得可愛，對人的包容性也出奇的大，有時會被利用，甚至有時被人利用而不自知。',
  },
  {
    id: 129,
    question: '我並不需要與很多人建立起親近的人際關係，我會把大部分的精力，專注在思想哲理、抽象概念和超自然等內心世界的探討上。',
  },
  {
    id: 130,
    question: '當遇到挫折時，我喜歡自己面對困難，當別人對我伸出援手時，往往會覺得不自在，無法坦然接受別人所釋出的善意。',
  },
  {
    id: 131,
    question: '工作時，我通常會制定短期、中期規劃，並會努力按照計畫實行，也幾乎都能堅持、貫徹原定計劃。',
  },
  {
    id: 132,
    question: '我工作時，通常會將工作內容做出妥善分配，往往能在截止日期前完成工作，因此常有充分時間做檢查和修正。',
  },
  {
    id: 133,
    question: '面對事務時，我偏愛收集所有可能資訊，並喜歡遵循可信賴的標準和執行程式，以確保事情進行都在掌握中。',
  },
  {
    id: 134,
    question: '我工作時，通常能心無旁騖將事情處理完備，有時會廢寢忘食，而危害身體健康。',
  },
  {
    id: 135,
    question: '我習慣“今日事、今日畢”，也常因我的堅持，可能會造成我周遭工作夥伴、朋友、家人的困擾。',
  },
  {
    id: 136,
    question: '做事時，我喜歡條理分明。因此，不管在家或是工作環境，總會將所有物品做好歸類、收納，讓人覺得我很嚴謹。',
  },
  {
    id: 137,
    question: '我是一個注重承諾的人，一旦答應別人就會努力完成，雖然常給自己帶來很大困擾、麻煩，但我還是堅持這個處事原則。',
  },
  {
    id: 138,
    question: '我工作時，常選擇沉潛、低調，不會到處誇耀自己的成就。',
  },
  {
    id: 139,
    question: '我相信“君子愛財、取之有道”，絕不因想多賺錢，而做出危害他人權益的事。',
  },
  {
    id: 140,
    question: '面對人際間的相處，我常抱持著“寧人負我、我不負人”的心態。因此，有時會讓自己遭受權益損失。',
  },
];